import {
  addMyPaymentTermOrder, addingMyPaymentTermOrderItem, setTariffSimulationPasswordInputDialog,
  setMyPaymentTermSearchText, setTappedTermBlNo, setMyPaymentSelectedTab,
} from '../simple-action';
import { ROUTE_NAME_MY_PAYMENT } from '../../../constant';
import { uploadTermOrderItem } from '../../../helper';
import LocalizedString from '../../../localization';

export default (item, serviceName, password, navigateTo) => async (dispatch, getState) => {
  const { token } = getState().authentication;
  const { blNo, totalPayment } = item;

  try {
    dispatch(addingMyPaymentTermOrderItem(true));

    if (!password) {
      throw new Error(LocalizedString.common.errMsgEmptyPassword);
    }

    const itemSent = {
      blNumber: blNo,
      service: serviceName,
      amount: totalPayment,
      info: getState().uiTariffSimulation.chosenDate,
      paymentOnBehalfOf: getState().uiTariffSimulation.selectedPaymentBehalfOf,
    };

    const itemGot = await uploadTermOrderItem(itemSent, token, password);

    dispatch(addMyPaymentTermOrder(itemGot));

    dispatch(setTariffSimulationPasswordInputDialog(false));

    dispatch(setMyPaymentTermSearchText(''));
    dispatch(setTappedTermBlNo(''));
    dispatch(setMyPaymentSelectedTab(1)); // term tab
    navigateTo(ROUTE_NAME_MY_PAYMENT);
  } finally {
    dispatch(addingMyPaymentTermOrderItem(false));
  }
};
